// src/App.tsx
import "../Report.css";
import ReportHeader from "@/components/ReportHeader";
import { useAtom } from "jotai";
import { companyAtom } from "@/store/company";
import { datesAtom } from "@/store/dates";
import { prepareDisplayDate } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";
import ReportFooter from "@/components/ReportFooter";
import { levelsAtom } from "@/store/levels";
import { Trans, useTranslation } from "react-i18next";

interface IntroPageProps {
  title: string;
  page?: number;
}

export const IntroPage = ({ title, page }: IntroPageProps) => {
  const { t } = useTranslation();
  const [company] = useAtom(companyAtom);
  const [dates] = useAtom(datesAtom);
  const [levels] = useAtom(levelsAtom);

  return (
    <section className="pdf-page">
      <ReportHeader title={title} />
      <div className="pdf-content text-xl ">
        <p className="mb-4">
          <Trans
            i18nKey="intro_1"
            values={{
              company: company?.name,
              fromDate: prepareDisplayDate(
                dates?.fromDate,
              )?.toLocaleDateString(),
              toDate: prepareDisplayDate(dates?.toDate)?.toLocaleDateString(),
              levels: levels?.join(", "),
            }}
            components={{
              strong: <strong />,
            }}
          />
        </p>
        <p className="mb-6">{t("intro_2", { company: company?.name })}</p>

        <Card className="max-w-[800px]">
          <CardContent className="p-4">
            <div className="grid grid-cols-2 gap-2">
              <div>
                <p className="font-medium mb-2">{company?.name}</p>
                <p className="text-xs">{company?.vat}</p>
                <p className="text-xs">{company?.address}</p>
                <p className="text-xs">{company?.cp}</p>
                <p className="text-xs">{company?.city}</p>
                <p className="text-xs">{company?.province}</p>
                <p className="text-xs">{company?.country?.name}</p>

                <p className="font-medium mb-2">{t("Representante")}:</p>
                <p className="text-xs">{company?.phone}</p>
                <p className="text-xs">{company?.email}</p>
                <p className="text-xs">{company?.web}</p>
                <p className="text-xs">
                  Clasificacion CNAE {company?.sector?.name}
                </p>
              </div>
              <div>
                <p className="mt-3 font-medium">
                  {t("Responsables del Cálculo y Plan")}:
                </p>
                <p className="text-xs">Carbontech </p>
                <p className="text-xs">Empresa: [CIF]</p>
                <p className="text-xs">Domicilio social: [Direccion]</p>
                <p className="text-xs">Email: [Email]</p>
                <p className="text-xs">Web: [Web]</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <ReportFooter page={page} />
    </section>
  );
};
